import React, { useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Mail, ArrowLeft, CheckCircle2 } from "lucide-react";
import YSVLogo from "@/components/YSVLogo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const ForgotPasswordPage = () => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) { setError("Enter your email"); return; }
    setSubmitting(true); setError(null);
    try {
      await axios.post(`${API}/auth/forgot-password`, { email: email.trim() });
      setSubmitted(true);
    } catch (err) {
      setError(err.response?.data?.detail || "Request failed");
    } finally { setSubmitting(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#0a0a0c', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: 'min(96vw, 440px)' }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <YSVLogo size="md" />
        </div>

        <div className="glass-card" style={{ padding: 32 }}>
          <Link to="/login" data-testid="forgot-back-link" style={{
            display: 'inline-flex', alignItems: 'center', gap: 6,
            color: 'var(--text-secondary)', textDecoration: 'none',
            fontSize: 13, marginBottom: 16, fontFamily: "'DM Sans', sans-serif",
          }}><ArrowLeft size={14} /> Back to sign in</Link>

          {submitted ? (
            <div data-testid="forgot-success" style={{ textAlign: 'center', padding: '20px 0' }}>
              <CheckCircle2 size={52} style={{ color: '#4caf50', marginBottom: 14 }} />
              <h2 style={{ fontSize: 22, fontWeight: 800, fontFamily: "'Outfit', sans-serif", marginBottom: 10, color: '#fff' }}>Check your email</h2>
              <p style={{ fontSize: 14, color: 'var(--text-secondary)', lineHeight: 1.6 }}>
                If an account exists for <strong style={{ color: '#fff' }}>{email}</strong>, we've sent a password reset link.
              </p>
              <p style={{ fontSize: 12, color: 'var(--text-secondary)', marginTop: 12 }}>
                The link expires in 30 minutes. Didn't receive it? Check spam, then{" "}
                <button onClick={() => setSubmitted(false)} style={{ background: 'none', border: 'none', color: 'var(--cyan)', cursor: 'pointer', textDecoration: 'underline', fontFamily: 'inherit', fontSize: 12 }}>try again</button>.
              </p>
            </div>
          ) : (
            <>
              <h1 style={{ fontSize: 24, fontWeight: 800, fontFamily: "'Outfit', sans-serif", marginBottom: 8, color: '#fff' }}>Forgot your password?</h1>
              <p style={{ fontSize: 13, color: 'var(--text-secondary)', marginBottom: 20 }}>Enter the email you signed up with and we'll send a reset link.</p>

              <form onSubmit={submit}>
                <label style={{ fontSize: 12, color: 'var(--text-secondary)' }}>Email
                  <div style={{ position: 'relative', marginTop: 4 }}>
                    <Mail size={14} style={{ position: 'absolute', top: 14, left: 12, color: '#666' }} />
                    <input
                      data-testid="forgot-email"
                      type="email"
                      required
                      className="input-field"
                      placeholder="you@example.com"
                      value={email}
                      onChange={e => setEmail(e.target.value)}
                      style={{ paddingLeft: 36 }}
                    />
                  </div>
                </label>

                {error && <p data-testid="forgot-error" style={{ color: '#f44336', fontSize: 13, marginTop: 10 }}>{error}</p>}

                <button
                  data-testid="forgot-submit"
                  type="submit"
                  disabled={submitting}
                  className="btn-primary"
                  style={{ width: '100%', marginTop: 16, padding: '12px 16px', opacity: submitting ? 0.6 : 1 }}
                >{submitting ? "Sending…" : "Send reset link"}</button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
